/**
 * Menu.Title theme values.
 */
import { Components } from "@oui/system/components"
import { css } from "@oui/system"
import spacing from "../../spacing"

const appearances: Components["Menu"]["Title"]["appearances"] = {
  default: css`
    min-height: 40px;
    min-width: 40px;
    padding: 0 ${spacing.sm}px;
  `
}

export default { appearances }
